import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "manager-report-detail resident-report-detail" }
const _hoisted_2 = { class: "manager-report-detail__header resident-report-detail__header" }
const _hoisted_3 = { class: "manager-report-detail__header-section resident-report-detail__title-container" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 0,
  class: "manager-report-detail__header-actions resident-report-detail__header-actions"
}
const _hoisted_6 = {
  type: "button",
  class: "manager-report-detail__status-select"
}
const _hoisted_7 = { class: "manager-report-detail__status-label" }
const _hoisted_8 = ["href"]
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 0,
  class: "manager-report-detail__loading resident-report-detail__loading"
}
const _hoisted_11 = {
  key: 1,
  class: "manager-report-detail__loading resident-report-detail__loading"
}
const _hoisted_12 = { class: "resident-report-detail__general-section" }
const _hoisted_13 = { class: "resident-report-detail__general-section--field-row" }
const _hoisted_14 = { class: "field-with-label" }
const _hoisted_15 = { class: "field-with-label__value" }
const _hoisted_16 = { class: "field-with-label" }
const _hoisted_17 = { class: "field-with-label__value" }
const _hoisted_18 = { class: "resident-report-detail__general-section--field-row" }
const _hoisted_19 = { class: "field-with-label" }
const _hoisted_20 = { class: "field-with-label__value" }
const _hoisted_21 = { class: "field-with-label" }
const _hoisted_22 = { class: "field-with-label__value" }
const _hoisted_23 = { class: "resident-report-detail__metrics-section" }
const _hoisted_24 = { class: "resident-report-detail__metrics-section--table" }
const _hoisted_25 = { class: "resident-report-detail__details-section" }
const _hoisted_26 = { class: "resident-report-detail__details-list" }
const _hoisted_27 = { class: "resident-report-detail__details-item--label" }
const _hoisted_28 = { class: "resident-report-detail__details-item--value" }
const _hoisted_29 = { class: "resident-report-detail__section" }
const _hoisted_30 = {
  key: 0,
  class: "resident-report-detail__documents"
}
const _hoisted_31 = ["src"]
const _hoisted_32 = { class: "resident-report-detail__document-content" }
const _hoisted_33 = ["href"]
const _hoisted_34 = ["href"]
const _hoisted_35 = ["src"]
const _hoisted_36 = {
  key: 1,
  class: "resident-report-detail__empty-documents"
}
const _hoisted_37 = { class: "manager-report-detail__signature-section" }
const _hoisted_38 = { class: "manager-report-detail__signature-status-row" }
const _hoisted_39 = { class: "field-with-label" }
const _hoisted_40 = { class: "manager-report-detail__signature-status" }
const _hoisted_41 = ["src"]
const _hoisted_42 = { class: "manager-report-detail__signature-actions" }
const _hoisted_43 = ["href"]
const _hoisted_44 = ["disabled"]
const _hoisted_45 = { class: "manager-report-detail__signature-fields" }
const _hoisted_46 = { class: "field-with-label" }
const _hoisted_47 = { class: "field-with-label__value" }
const _hoisted_48 = { class: "field-with-label" }
const _hoisted_49 = { class: "field-with-label__value" }
const _hoisted_50 = { class: "field-with-label" }
const _hoisted_51 = { class: "field-with-label__value" }
const _hoisted_52 = { class: "field-with-label" }
const _hoisted_53 = { class: "field-with-label__value" }

import { computed, onMounted, ref, watch } from 'vue';
import type { MenuProps } from 'ant-design-vue';
import ArrowDownIcon from '@/js/components/icons/ArrowDownIcon.vue';
import {
  showStcErrorNotification,
  showStcInfoNotification,
  showStcSuccessNotification,
} from '@/js/components/stc-notification';
import { getAssetsPath } from '@/js/utils/getAssetsDir';
import ReportRevisionDrawer from './ReportRevisionDrawer.vue';
import {
  applyManagerReport,
  checkManagerReportSign,
  fetchManagerReportDetail,
  getManagerReportArchiveUrl,
  rejectManagerReport,
} from './manager-reports-api';
import {
  getStatusModifier,
  mapManagerReportToDetailView,
  type ManagerReportDetailViewModel,
} from './map-manager-report';
import type { ManagerReportSignCheckResult } from './types';
import type { ManagerReportRow, ManagerReportStatusOption } from './types';
import { MANAGER_REPORT_STATUS_OPTIONS } from './types';


export default /*@__PURE__*/_defineComponent({
  __name: 'ReportDetailView',
  props: {
    report: {}
  },
  emits: ["back", "updated"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const LEFT_ARROW_ICON = getAssetsPath('/assets/images/icons/share-icons/left-arrow.svg');
const DOWNLOAD_ICON = getAssetsPath('/assets/images/icons/share-icons/download-icon.svg');
const DOC_PDF_ICON = getAssetsPath('/assets/images/icons/doc/doc_pdf.svg');
const VALID_ICON = getAssetsPath('/assets/images/icons/share-icons/success-circle-icon.svg');

const statusOptions = MANAGER_REPORT_STATUS_OPTIONS;
const statusDropdownOptions = computed(() =>
  statusOptions.filter((option) => option.code !== 'draft'),
);
const loading = ref(false);
const error = ref('');
const detail = ref<ManagerReportDetailViewModel | null>(null);
const statusSaving = ref(false);
const revisionDrawerOpen = ref(false);
const revisionSaving = ref(false);
const signChecking = ref(false);

function isReviewStatus(status?: string | null): boolean {
  return getStatusModifier(status) === 'review';
}

function isStatusOptionDisabled(option: ManagerReportStatusOption): boolean {
  if (!detail.value || statusSaving.value || revisionSaving.value) {
    return true;
  }

  if (option.name === detail.value.status) {
    return true;
  }

  const canChangeFromReview = isReviewStatus(detail.value.status);

  if (option.code === 'new') {
    return true;
  }

  return !canChangeFromReview;
}

async function loadSignatureCheck(reportId: number): Promise<void> {
  signChecking.value = true;

  try {
    const result = await checkManagerReportSign(reportId);

    if (detail.value?.signature) {
      detail.value.signature.isValid = Boolean(result.verify);
    }

    showSignatureCheckNotification(result);
  } catch (checkError) {
    showStcErrorNotification(
      checkError instanceof Error ? checkError.message : 'Не удалось проверить подпись',
    );
  } finally {
    signChecking.value = false;
  }
}

function formatSignCheckNotificationDescription(result: ManagerReportSignCheckResult): string {
  return [
    `Подписант: ${result.fio || '—'}`,
    `Организация: ${result.nameOrganization || '—'}`,
    `УЦ: ${result.certAuthority || '—'}`,
    `Сертификат, №: ${result.certNumber || '—'}`,
    `Срок действия: ${result.dateEndSert || '—'}`,
    `Дата подписания: ${result.dateSign || '—'}`,
  ].join('\n');
}

function showSignatureCheckNotification(result: ManagerReportSignCheckResult): void {
  const title = result.verify ? 'Подпись действительна' : 'Подпись недействительна';
  const description = formatSignCheckNotificationDescription(result);

  if (result.verify) {
    showStcSuccessNotification(description, title, { duration: 15 });
    return;
  }

  showStcInfoNotification(description, title, { duration: 15 });
}

async function handleCheckSign() {
  if (!detail.value?.signature || signChecking.value) {
    return;
  }

  await loadSignatureCheck(detail.value.id);
}

async function loadDetail() {
  loading.value = true;
  error.value = '';

  try {
    const report = await fetchManagerReportDetail(props.report.id, props.report);
    detail.value = mapManagerReportToDetailView(report, getManagerReportArchiveUrl(report.id));
  } catch (loadError) {
    detail.value = null;
    error.value = loadError instanceof Error ? loadError.message : 'Не удалось загрузить отчёт';
  } finally {
    loading.value = false;
  }
}

const handleStatusChange: MenuProps['onClick'] = async ({ key }) => {
  if (!detail.value || statusSaving.value || revisionSaving.value) {
    return;
  }

  const option = statusDropdownOptions.value.find((item) => item.code === String(key));
  if (!option || isStatusOptionDisabled(option)) {
    return;
  }

  if (option.code === 'revision') {
    revisionDrawerOpen.value = true;
    return;
  }

  statusSaving.value = true;

  try {
    if (option.code === 'accepted') {
      const successMessage = await applyManagerReport(detail.value.id);
      detail.value.status = option.name;
      detail.value.statusModifier = getStatusModifier(option.name);
      emit('updated');
      showStcSuccessNotification(successMessage || 'Отчёт принят');
      return;
    }

    showStcInfoNotification('Изменение на выбранный статус недоступно');
  } catch (updateError) {
    showStcErrorNotification(
      updateError instanceof Error ? updateError.message : 'Не удалось обновить статус отчёта',
    );
  } finally {
    statusSaving.value = false;
  }
};

async function handleRevisionSubmit(payload: { comment: string; files: File[] }) {
  if (!detail.value || revisionSaving.value) {
    return;
  }

  revisionSaving.value = true;

  try {
    const successMessage = await rejectManagerReport(detail.value.id, payload);

    const revisionOption = statusOptions.find((item) => item.code === 'revision');

    if (revisionOption) {
      detail.value.status = revisionOption.name;
      detail.value.statusModifier = getStatusModifier(revisionOption.name);
    }

    revisionDrawerOpen.value = false;
    emit('updated');
    showStcSuccessNotification(successMessage || 'Отчёт отправлен на доработку');
  } catch (updateError) {
    showStcErrorNotification(
      updateError instanceof Error ? updateError.message : 'Не удалось вернуть отчёт на доработку',
    );
  } finally {
    revisionSaving.value = false;
  }
}

watch(
  () => props.report.id,
  () => {
    void loadDetail();
  },
);

onMounted(() => {
  void loadDetail();
});

return (_ctx: any,_cache: any) => {
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_divider = _resolveComponent("a-divider")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "manager-report-detail__back",
          "aria-label": "Вернуться к списку отчётов",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('back')))
        }, [
          _createElementVNode("img", {
            src: _unref(LEFT_ARROW_ICON),
            alt: "",
            "aria-hidden": "true"
          }, null, 8, _hoisted_4)
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "manager-report-detail__title resident-report-detail__title-container--title" }, " Отчет ", -1))
      ]),
      (detail.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_a_dropdown, { trigger: ['click'] }, {
              overlay: _withCtx(() => [
                _createVNode(_component_a_menu, { onClick: handleStatusChange }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statusDropdownOptions.value, (option) => {
                      return (_openBlock(), _createBlock(_component_a_menu_item, {
                        key: option.code,
                        disabled: isStatusOptionDisabled(option)
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", {
                            class: _normalizeClass(["manager-report-detail__status-option", {
                    'manager-report-detail__status-option--selected': option.name === detail.value.status,
                  }])
                          }, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["manager-report-detail__status-dot", `manager-report-detail__status-dot--${_unref(getStatusModifier)(option.name)}`]),
                              "aria-hidden": "true"
                            }, null, 2),
                            _createElementVNode("span", null, _toDisplayString(option.name), 1)
                          ], 2)
                        ]),
                        _: 2
                      }, 1032, ["disabled"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createElementVNode("button", _hoisted_6, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["manager-report-detail__status-dot", `manager-report-detail__status-dot--${detail.value.statusModifier}`]),
                    "aria-hidden": "true"
                  }, null, 2),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(detail.value.status), 1),
                  _createVNode(ArrowDownIcon, { class: "manager-report-detail__status-icon" })
                ])
              ]),
              _: 1
            }),
            _cache[3] || (_cache[3] = _createElementVNode("hr", { class: "resident-report-detail__header-actions--divider" }, null, -1)),
            _createVNode(_component_a_tooltip, {
              title: "Скачать",
              placement: "bottom"
            }, {
              default: _withCtx(() => [
                _createElementVNode("a", {
                  class: "resident-report-detail__icon-action",
                  href: detail.value.downloadUrl,
                  target: "_blank",
                  rel: "noopener",
                  "aria-label": "Скачать отчёт"
                }, [
                  _createElementVNode("img", {
                    src: _unref(DOWNLOAD_ICON),
                    alt: "",
                    "aria-hidden": "true"
                  }, null, 8, _hoisted_9)
                ], 8, _hoisted_8)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    (loading.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_10, " Загрузка... "))
      : (error.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(error.value), 1))
        : (detail.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _cache[21] || (_cache[21] = _createElementVNode("hr", { class: "resident-report-detail__divider header-divider" }, null, -1)),
              _createElementVNode("section", _hoisted_12, [
                _cache[8] || (_cache[8] = _createElementVNode("span", { class: "resident-report-detail__section-title" }, "Общее", -1)),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _cache[4] || (_cache[4] = _createElementVNode("span", { class: "field-with-label__label" }, "Название", -1)),
                    _createElementVNode("span", _hoisted_15, _toDisplayString(detail.value.title), 1)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _cache[5] || (_cache[5] = _createElementVNode("span", { class: "field-with-label__label" }, "Дата создания", -1)),
                    _createElementVNode("span", _hoisted_17, _toDisplayString(detail.value.createdAt), 1)
                  ])
                ]),
                _cache[9] || (_cache[9] = _createElementVNode("hr", { class: "resident-report-detail__general-section--divider" }, null, -1)),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _cache[6] || (_cache[6] = _createElementVNode("span", { class: "field-with-label__label" }, "Организация", -1)),
                    _createElementVNode("span", _hoisted_20, _toDisplayString(detail.value.companyName), 1)
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _cache[7] || (_cache[7] = _createElementVNode("span", { class: "field-with-label__label" }, "Отчетный период", -1)),
                    _createElementVNode("span", _hoisted_22, _toDisplayString(detail.value.reportYear), 1)
                  ])
                ])
              ]),
              _cache[22] || (_cache[22] = _createElementVNode("hr", { class: "resident-report-detail__divider" }, null, -1)),
              _createElementVNode("section", _hoisted_23, [
                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "resident-report-detail__metrics-section--title-container" }, [
                  _createElementVNode("span", { class: "resident-report-detail__metrics-section--title" }, "Показатели"),
                  _createElementVNode("span", { class: "resident-report-detail__metrics-section--description" }, " За отчетный выбранный период ")
                ], -1)),
                _createElementVNode("table", _hoisted_24, [
                  _cache[10] || (_cache[10] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, "Показатель"),
                      _createElementVNode("th", null, "План"),
                      _createElementVNode("th", null, "Факт"),
                      _createElementVNode("th", null, "Отклонение, %")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.value.metrics, (metric) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: metric.label
                      }, [
                        _createElementVNode("td", null, _toDisplayString(metric.label), 1),
                        _createElementVNode("td", null, _toDisplayString(metric.plan), 1),
                        _createElementVNode("td", null, _toDisplayString(metric.fact), 1),
                        _createElementVNode("td", null, _toDisplayString(metric.deviation), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _cache[23] || (_cache[23] = _createElementVNode("hr", { class: "resident-report-detail__divider" }, null, -1)),
              _createElementVNode("section", _hoisted_25, [
                _cache[12] || (_cache[12] = _createElementVNode("span", { class: "resident-report-detail__section-title" }, "Детали", -1)),
                _createElementVNode("dl", _hoisted_26, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.value.details, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.label,
                      class: "resident-report-detail__details-item"
                    }, [
                      _createElementVNode("span", _hoisted_27, _toDisplayString(item.label), 1),
                      _createElementVNode("span", _hoisted_28, _toDisplayString(item.value), 1)
                    ]))
                  }), 128))
                ])
              ]),
              _cache[24] || (_cache[24] = _createElementVNode("hr", { class: "resident-report-detail__divider" }, null, -1)),
              _createElementVNode("section", _hoisted_29, [
                _cache[13] || (_cache[13] = _createElementVNode("span", { class: "resident-report-detail__section-title" }, "Документы", -1)),
                (detail.value.documents.length)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_30, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.value.documents, (file) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: file.url + file.name,
                          class: "resident-report-detail__document manager-report-detail__document"
                        }, [
                          _createElementVNode("img", {
                            src: _unref(DOC_PDF_ICON),
                            alt: "",
                            class: "resident-report-detail__document-icon"
                          }, null, 8, _hoisted_31),
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("a", {
                              href: file.url,
                              target: "_blank",
                              rel: "noopener",
                              download: ""
                            }, _toDisplayString(file.name), 9, _hoisted_33),
                            _createElementVNode("span", null, _toDisplayString(file.format) + " / " + _toDisplayString(file.size), 1)
                          ]),
                          _createElementVNode("a", {
                            href: file.url,
                            class: "manager-report-detail__document-download",
                            target: "_blank",
                            rel: "noopener",
                            download: "",
                            "aria-label": "Скачать документ"
                          }, [
                            _createElementVNode("img", { src: _unref(DOWNLOAD_ICON) }, null, 8, _hoisted_35)
                          ], 8, _hoisted_34)
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_36, "Документы не загружены"))
              ]),
              (detail.value.signature)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _cache[20] || (_cache[20] = _createElementVNode("hr", { class: "resident-report-detail__divider" }, null, -1)),
                    _createElementVNode("section", _hoisted_37, [
                      _cache[19] || (_cache[19] = _createElementVNode("span", { class: "resident-report-detail__section-title" }, "Эл. подпись", -1)),
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, [
                          _cache[14] || (_cache[14] = _createElementVNode("span", { class: "field-with-label__label" }, "Статус", -1)),
                          _createElementVNode("span", _hoisted_40, [
                            (detail.value.signature.isValid)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: _unref(VALID_ICON)
                                }, null, 8, _hoisted_41))
                              : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(detail.value.signature.isValid ? 'Действительно' : 'Недействительно'), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("a", {
                            href: detail.value.downloadUrl,
                            class: "btn btn-secondary btn-medium",
                            target: "_blank",
                            rel: "noopener"
                          }, " Скачать подпись ", 8, _hoisted_43),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-secondary btn-medium",
                            disabled: signChecking.value,
                            onClick: handleCheckSign
                          }, _toDisplayString(signChecking.value ? 'Проверка...' : 'Проверить подпись'), 9, _hoisted_44)
                        ])
                      ]),
                      _createVNode(_component_a_divider, { class: "manager-report-detail__divider" }),
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("div", _hoisted_46, [
                          _cache[15] || (_cache[15] = _createElementVNode("span", { class: "field-with-label__label" }, "Подписант", -1)),
                          _createElementVNode("span", _hoisted_47, _toDisplayString(detail.value.signature.signatory), 1)
                        ]),
                        _createElementVNode("div", _hoisted_48, [
                          _cache[16] || (_cache[16] = _createElementVNode("span", { class: "field-with-label__label" }, "Организация", -1)),
                          _createElementVNode("span", _hoisted_49, _toDisplayString(detail.value.signature.organization), 1)
                        ]),
                        _createElementVNode("div", _hoisted_50, [
                          _cache[17] || (_cache[17] = _createElementVNode("span", { class: "field-with-label__label" }, "УЦ", -1)),
                          _createElementVNode("span", _hoisted_51, _toDisplayString(detail.value.signature.certAuthority), 1)
                        ]),
                        _createElementVNode("div", _hoisted_52, [
                          _cache[18] || (_cache[18] = _createElementVNode("span", { class: "field-with-label__label" }, "Дата / время подписания", -1)),
                          _createElementVNode("span", _hoisted_53, _toDisplayString(detail.value.signature.signedAt), 1)
                        ])
                      ])
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
    _createVNode(ReportRevisionDrawer, {
      open: revisionDrawerOpen.value,
      "onUpdate:open": _cache[1] || (_cache[1] = ($event: any) => ((revisionDrawerOpen).value = $event)),
      saving: revisionSaving.value,
      onSubmit: handleRevisionSubmit
    }, null, 8, ["open", "saving"])
  ]))
}
}

})